var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('div',{staticClass:"body",attrs:{"slot":"body"},slot:"body"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.print}},[_vm._v(" 打印预览 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }